var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M9.63615 3.3332H3.50409C3.03943 3.3332 2.5938 3.50879 2.26523 3.82135C1.93666 4.13391 1.75208 4.55784 1.75208 4.99986V16.6665C1.75208 17.1086 1.93666 17.5325 2.26523 17.845C2.5938 18.1576 3.03943 18.3332 3.50409 18.3332H15.7682C16.2329 18.3332 16.6785 18.1576 17.0071 17.845C17.3356 17.5325 17.5202 17.1086 17.5202 16.6665V10.8332M16.2062 2.0832C16.5547 1.75168 17.0274 1.56543 17.5202 1.56543C18.0131 1.56543 18.4857 1.75168 18.8342 2.0832C19.1827 2.41472 19.3785 2.86436 19.3785 3.3332C19.3785 3.80204 19.1827 4.25168 18.8342 4.5832L10.5122 12.4999L7.00813 13.3332L7.88414 9.99986L16.2062 2.0832Z",
    stroke: "#494F61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e0e8d8c3345eb5033adf665cebe7249b.svg";
export { ForwardRef as ReactComponent };